const profileAvatarStyles = {
  shape: "square",
  size: "medium",
  color: "neutral",
  iconType: "none",
  shade: "light",
  randomizeColor: true,
};

export default profileAvatarStyles;
